import client from './api-client';

export const getConfiguracionForm15 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form15: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboModoContacto = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboModoContactoModal: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboRespuestaContacto = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboRespuestaContactoModal: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaHistorialModal = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/contacto/hitos?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                grillaHistorial: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
 
export const getDatosUltimoContacto = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/contacto?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosUltimoContacto: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
 
export const postActualizarContacto = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/contacto', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaContacto: response.data};
        } else {
            return {respuestaContacto: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const getConfiguracionForm42 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form42: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const verDocumento = async(query) => {
    try {
        
        const response = await client.verDocumento(`get-file?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return response.data;
        } else {
            return response.data;
        }

    } catch(error){
        throw error;
    }
}